export function jsonParser(str) {
    const validJson = JSON.parse(str);
    return validJson;
}
